// extracted by mini-css-extract-plugin
export default {"form":"form-create-receive_form__asuAz","row":"form-create-receive_row__tICxl","select":"form-create-receive_select__UteY8","default":"form-create-receive_default__ZtNsU"};